import request from '../request.js'

// 主体菜单范围管理 - 根据主体id，获取主体菜单范围信息
const getMenuRangeByLimitId = function (data) {
    return request({
        url: 'sysLimitMenuRange/getMenuRangeLimitId',
        method: 'post',
        data
    })
}

// 主体菜单范围管理 - 主体菜单范围信息 保存/修改
const saveOrUpdateLimitMenuRange = function (data) {
    return request({
        url: 'sysLimitMenuRange/saveLimitMenuRange',
        method: 'post',
        data
    })
}

export {
    getMenuRangeByLimitId,saveOrUpdateLimitMenuRange
}